class NativeUtil {
  static postMessage(methodName: string, ...args: any[]) {
    try {
      const platform = this.checkPlatform();
      console.log({ methodName, args });
      if (platform === 'ios') {
        // @ts-ignore
        window.webkit.messageHandlers[methodName].postMessage(...args);
      } else {
        // @ts-ignore
        window.paperlot[methodName](...args);
      }
    } catch (e) {
      console.error(e);
    }
  }

  private static checkPlatform(): 'ios'| 'android' {
    const agent = navigator.userAgent.toLowerCase();
    if (agent.includes('iphone') || agent.includes('ipad') || agent.includes('ipod')) {
      return 'ios';
    }
    return 'android';
  }
}

export default NativeUtil;
